// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__14mid","dismiss":"styles_dismiss__1SJ6V"};